<template>
	<div class="app-content-layout display-flex flex-column">
		<div class="header">
			<slot name="header" />
		</div>
		<slot />
	</div>
</template>

<script>
// import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'AppContentLayout',
	computed: {
		// ...mapGetters(['isUserRegistrationLoading']),
	},
	mounted() {
		// setTimeout(() => this.setIsUserRegistrationLoading(false), 100);
	},
	methods: {
		// ...mapActions(['setIsUserRegistrationLoading']),
	},
};
</script>

<style scoped lang="scss">
.app-content-layout {
	$margin-top: 3%;

	height: calc(100% - #{$margin-top});
	padding: $margin-top 0 0 0;
}
</style>
